import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { LogisticService, BusinesscoItem, StockplaceItem } from '../../../services/logistic.service';

@Component({
  selector: 'tt-purch-planning',
  templateUrl: './purch-planning.component.html',
  styleUrls: ['./purch-planning.component.css']
})
export class PurchPlanningComponent implements OnInit {
    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public selectListPortalUsers: Item[] = [];

    public selectListSuppliers: Item[] = [];

    public grid?: GridOptions;

    public creatingPurchase = false;

    public supplierButtons: FormButton[] = [
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'customersmenu', gotoParms: () => this.setting!.supplier_no ?? '' }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(2445))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!!this.setting) {
            this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.setting.businessco_no });
        }
    }

    private async loadPortalUserPurchases() {
        if (!!this.setting) {
            this.selectListPortalUsers = await this.logistic.getPurchaserPortalUsers({
                businessco_no: this.setting.businessco_no,
                add_all: '1'
            });
        }
    }

    private async loadSuppliers() {
        if (!!this.setting) {
            this.selectListSuppliers = await this.datatask.Post(653, {
                portal_user_keyno_purchaser: this.setting.portal_user_keyno_purchaser,
                businessco_no: this.setting.businessco_no,
                add_all: '1'
            });
        }
    }

    private loadGrid() {
        if (!!this.setting) {
            if (!this.grid) {
                this.grid = new Grid()
                    .setRememberId(this.setting.view_id)
                    .setLoadDataFunction({
                        method: this.setting?.p2_datatask_keyno,
                        parameters: this.setting
                    })
                    .setKendoConfig({ height: '100%' })
                    .setToolbar({ wrapping: true })
                    .setCustomToolbarButtons([{
                        name: 'customSave',
                        text: '',
                        func: () => this.saveItems(),
                        icon: 'save',
                        cssClass: '',
                        translate: false
                    }]);
            } else {
                this.grid?.gridfunc?.read();
            }
        }
    }

    private async saveItems() {
        if (!!this.setting && !!this.grid) {
            try {
                const currentData = (this.grid?.gridfunc?.getAllRows() ?? [])
                    .filter((row) => row['is_selected'] === true)
                    .map((row) => ({
                        stock_keyno: row['stock_keyno'],
                        supplier_no: row['supplier_no'],
                        purchase_quantity: row['purchase_quantity'],
                        deliverydate_wish: row['deliverydate_wish']
                    }));
                
                const response = (await this.datatask.Post(2447, {
                    stockplace_id: this.setting?.stockplace_id,
                    stocks: currentData
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.go('purchhead', { purch_internal_no: response?.purch_internal_no });
                }
            } finally {
                this.creatingPurchase = false;
            }
        }
    }

    public createChanges() {
        this.creatingPurchase = true;

        this.saveItems();
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'businessco_no':
                if (!!this.setting?.businessco_no) {
                    this.loadStockPlaces();
                    this.loadPortalUserPurchases();
                    this.loadSuppliers();
                }
                break;
            case 'stockplace_id':
                if (!!this.setting?.stockplace_id) this.loadGrid();
                break;
            case 'portal_user_keyno_purchaser':
                if (!!this.setting?.portal_user_keyno_purchaser) {
                    this.loadSuppliers();
                    this.loadGrid();
                }
                break;
            case 'supplier_no':
                if (!!this.setting?.supplier_no) this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();
        this.loadStockPlaces();
        this.loadPortalUserPurchases();
        this.loadSuppliers();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no: string;
    stockplace_id: string;
    portal_user_keyno_purchaser: string;
    supplier_no: string;
    p2_datatask_keyno: number;
    view_id: string;
}
